import * as React from 'react';
import { styles } from './styles';
import { BaseButton } from '@routes/event/create/components/BaseButton';

export const NoMatchesMessage: React.SFC<{
  onResetFiltersClick: React.MouseEventHandler<HTMLButtonElement>;
}> = ({ onResetFiltersClick }) => {
  return (
    <div className={styles.container}>
      <p className={styles.message}>
        We didn’t find any design combinations for your selection. Here are some other options to browse through, or you
        can{' '}
        <BaseButton className={styles.filterButton} onClick={onResetFiltersClick}>
          reset your filters.
        </BaseButton>
      </p>
    </div>
  );
};
